var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('rect',{attrs:{"x":"6.06","y":"6.07","width":"11.83","height":"11.83"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }